import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import moment from 'moment';

const useIndicatorsRange = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [indicatorList, setIndicatorList] = useState<any[]>();
  
  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  
  const { isLoading, refetch } = useQuery(
    [endpoints.management.indicators.range, [location.search]],
    () =>
      fetcher.management.postIndicatorRange({
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : moment().format('YYYY-01-01'),   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : moment().format('YYYY-12-31'),          
      }),
    {
      onSuccess: (res: indicatorListResDto) => {
        switch (res.code) {
          case 200:
            setIndicatorList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );


  return { indicatorList, refetch };
};

export default useIndicatorsRange;
